import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';

type LineInviteToken = {
  token: string;
  staffID?: number;
  guardianID?: number;
  createdAt: string;
  updatedAt: string;
};

// 招待トークンを確認する
export const checkInviteToken = async (token: string): Promise<ApiResult<LineInviteToken>> => {
  const { status, result } = await callApiWithoutToken<LineInviteToken>(
    `line/invite?token=${token}`,
    'GET'
  );
  return { status, result };
};
